<template>
    <DModal
        v-model="oneTimeDiscountForm.activity_log_comment"
        :title="__('customers.contracts.one_time_discount.title')"
        is-confirm
        :show="showModal || modalHasErrors"
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        :customer-id="contract?.customer_id ?? 0"
        :disabled-action="!discountAvailable"
        @confirm="createOneTimeDiscount()"
        @close="$emit('close-modal')"
    >
        <div style="padding: 20px;">
            <DRow style="margin-top: 16px;">
                <DCol>
                    <DInput
                        v-if="discountAvailable"
                        id="discount_percentage"
                        v-model="oneTimeDiscountForm.discount_value"
                        :label="__('customers.contracts.one_time_discount.description', {'max': maxPercentage})"
                        add-label-classes="required"
                        type="text"
                    />
                    <p
                        v-if="!discountAvailable"
                        class="help-block text-danger"
                    >
                        {{ __('customers.contracts.one_time_discount.not_available') }}
                    </p>
                    <p
                        v-if="errors.discount_value"
                        class="help-block text-danger"
                    >
                        {{ errors.discount_value }}
                    </p>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'OneTimeDiscountModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        discount: {
            type: Number,
            default: 0
        },
        showModal: {
            type: Boolean,
            default: false
        },
        discountAvailable: {
            type: Boolean,
            default: false
        },
        maxPercentage: {
            type: Number,
            default: 100
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            oneTimeDiscountForm: this.$inertia.form({
                discount_value: this.discount,
                activity_log_comment: '',
                incident_id: null
            }),
            errors: this.errorsData,
            modalHasErrors: false
        }
    },
    methods: {
        createOneTimeDiscount () {
            this.errors = {}
            this.oneTimeDiscountForm.post(this.$route('customers.customers.contracts.one_time_discount', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.modalHasErrors = false
                },
                onError: (error) => {
                    this.errors = error
                    this.modalHasErrors = true
                }
            })
        }
    }
}
</script>
